module.exports = __webpack_public_path__ + "static/media/Library.39b73fe6.glb";